import { Puff, Oval } from "react-loader-spinner";
import { getImageUrl } from "src/Common/common";

function ServiceTicketButton({ clicked, isLoading }) {
  return (
    <div
      onClick={!isLoading ? clicked : undefined}
      className="w-[152px] h-[32px] rounded-[8px] border-solid border-[1px] border-[#C9CEE2] bg-white shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] flex items-center justify-center cursor-pointer relative"
    >
      {isLoading ? (
        <div className="flex items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <Oval
            height={20}
            width={20}
            strokeWidth={4}
            color="#010D3D"
            secondaryColor="#80869E"
            ariaLabel="oval-loading"
            visible={true}
          />
        </div>
      ) : (
        <div className="flex gap-[8px] items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none">
            <path
              d="M7.1673 0C8.68548 6.21661e-05 10.1693 0.45116 11.431 1.29557C12.6927 2.14005 13.6756 3.3399 14.2545 4.74349C14.2568 4.74899 14.259 4.75483 14.261 4.76042C14.3582 5.02232 14.3583 5.31038 14.261 5.57227C14.259 5.57784 14.2568 5.58369 14.2545 5.58919C13.6756 6.99272 12.6927 8.19266 11.431 9.03711C10.1693 9.88149 8.68545 10.3326 7.1673 10.3327C5.64903 10.3327 4.16474 9.88155 2.90297 9.03711C1.64126 8.19266 0.658308 6.99272 0.0794069 5.58919C0.0771373 5.58369 0.074968 5.57785 0.0728964 5.57227C-0.0243166 5.31038 -0.0242811 5.02231 0.0728964 4.76042L0.0794069 4.74349C0.6583 3.3399 1.64121 2.14005 2.90297 1.29557C4.16476 0.451095 5.649 0 7.1673 0ZM7.1673 1C5.84704 1 4.55616 1.39197 3.45896 2.1263C2.36537 2.85823 1.51247 3.89727 1.00844 5.11263C0.996641 5.14744 0.997213 5.18526 1.00909 5.22005C1.51314 6.43525 2.36549 7.47453 3.45896 8.20638C4.55615 8.94067 5.84707 9.33268 7.1673 9.33268C8.48741 9.33262 9.77789 8.94061 10.875 8.20638C11.9684 7.47458 12.8201 6.43515 13.3242 5.22005C13.3362 5.18513 13.3367 5.14757 13.3248 5.11263C12.8208 3.89737 11.9685 2.85818 10.875 2.1263C9.77787 1.39204 8.48744 1.00006 7.1673 1Z"
              fill="#1A2332"
            />
            <path
              d="M8.66698 5.16626C8.66698 4.33783 7.99541 3.66626 7.16698 3.66626C6.33856 3.66626 5.66698 4.33783 5.66698 5.16626C5.66698 5.99468 6.33856 6.66626 7.16698 6.66626C7.99541 6.66626 8.66698 5.99468 8.66698 5.16626ZM9.66698 5.16626C9.66698 6.54697 8.5477 7.66626 7.16698 7.66626C5.78627 7.66626 4.66698 6.54697 4.66698 5.16626C4.66698 3.78554 5.78627 2.66626 7.16698 2.66626C8.5477 2.66626 9.66698 3.78554 9.66698 5.16626Z"
              fill="#1A2332"
            />
          </svg>
          <p className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] capitalize text-[#1A2332]">
            SERVICE TICKET
          </p>
        </div>
      )}
    </div>
  );
}

export default ServiceTicketButton;
